import React from 'react'
import { validateDomain } from 'Utils/validation'
import { SelectOption } from 'Types/Option'
import { MAX_DOMAINS, createOption } from '../helpers'
import { MultipleDomainInput } from '../../features/MultiDomainInput'

type AddDomainInputProps = {
  domains: SelectOption[]
  setDomains: (a: SelectOption[]) => void
}

export const AddDomainsInput = ({ domains, setDomains }: AddDomainInputProps) => {
  // In case used pastes space separated domains
  const makeDomainsFromStringSpaceSeparated = (input: string) => {
    const previousDomains = domains.map((domain) => domain.value)

    const domainsArray = input.split(/,| /).map((domain) => domain.toLowerCase()) // parse the domain - save as lower case
    const domainsValidated = domainsArray.filter(
      (domain) => validateDomain(domain) && !previousDomains.includes(domain)
    )

    // Check if there is space for new domains
    const maxDomains = MAX_DOMAINS - domains.length
    domainsValidated.splice(maxDomains)

    setDomains(
      [...previousDomains, ...domainsValidated].map((domain) => createOption(domain)).flat()
    )
  }

  const addDomain = (inputValue: string) => {
    makeDomainsFromStringSpaceSeparated(inputValue)
  }

  return (
    <MultipleDomainInput
      addDomain={addDomain}
      domains={domains}
      setDomains={setDomains}
      isClearable={false}
    />
  )
}
